import * as Meal from './components/Meal/Meal.css';
import * as Details from './components/Details/Details.css';

export default {
	Meal,
	Details
};
